import axios from 'axios';
import {
  createReviewUrl,
  delPhotoFromProduct,
  delReviewUrl,
  FOR_DAYS_URL,
  getProductByIdUrl,
  getReviewsUrl,
  PRODUCTS_URL,
  setProductMainPhotoUrl,
} from '../constants';
import { IProductFilter, IReviewCreate } from '../interfaces/product';

export const createProduct = (body: FormData) => axios.post(`/api/shop/product`, body);

export const editProduct = (id: number, files: FormData) =>
  axios.post(getProductByIdUrl(id), files, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const deleteProduct = (id: number | undefined) =>
  axios.delete(getProductByIdUrl(id || -1));

export const getProductById = (id: number) => axios.get(getProductByIdUrl(id));

export const getFavoriteProducts = () => axios.get('/api/shop/products/favorites');

export const getProducts = ({
  page = 1,
  perPage = 20,
  companyId,
  categoryId,
  search,
  filter = {},
  active = undefined,
}: {
  page: number;
  perPage: number;
  companyId?: number;
  categoryId?: number;
  search?: string;
  filter?: Partial<IProductFilter>;
  active?: boolean | undefined;
}) => {
  if (search) {
    let url = `/api/shop/products/all/?page=${page}&per_page=${perPage}`;
    if (search) url += `&text=${search}`;
    return axios.get(url);
  }
  if (companyId) {
    if (categoryId) {
      if (active) {
        return axios.post(
          `/api/shop/category/${categoryId}/products?page=${page}&per_page=${perPage}&company_id=${companyId}&active=${active}`
        );
      }
      return axios.post(
        `/api/shop/category/${categoryId}/products?page=${page}&per_page=${perPage}&company_id=${companyId}`
      );
    }
    if (active)
      return axios.get(
        `/api/shop/company/${companyId}/products?page=${page}&per_page=${perPage}&active=${active}`
      );
    return axios.get(
      `/api/shop/company/${companyId}/products?page=${page}&per_page=${perPage}`
    );
  }
  if (companyId && categoryId && active) {
    return axios.post(
      `/api/shop/category/${categoryId}/products?page=${page}&per_page=${perPage}&company_id=${companyId}&active=${active}`
    );
  }
  if (categoryId) {
    if (!filter.parameters) {
      if (active)
        return axios.post(
          `/api/shop/category/${categoryId}/products?page=${page}&per_page=${perPage}&active=${active}`
        );
      return axios.post(
        `/api/shop/category/${categoryId}/products?page=${page}&per_page=${perPage}`
      );
    }
    const formData = new FormData();
    formData.append('parameters', JSON.stringify(filter.parameters));
    return axios.post(
      `/api/shop/category/${categoryId}/products?page=${page}&per_page=${perPage}&price_from=${filter.price_from}&price_to=${filter.price_to}`,
      formData
    );
  }

  if (filter.parameters) {
    const formData = new FormData();
    formData.append('parameters', JSON.stringify(filter.parameters));
    return axios.post(
      `/api/shop/category/${
        categoryId || 0
      }/products?page=${page}&per_page=${perPage}&price_from=${filter.price_from}&price_to=${
        filter.price_to
      }`,
      formData
    );
  }

  const body = {
    price_from: filter.price_from ? +filter.price_from : null,
    price_to: filter.price_to ? +filter.price_to : null,
    active,
  };

  return axios.post(PRODUCTS_URL, body, {
    params: {
      page,
      per_page: perPage,
    },
  });
};

export const delPhoto = (photoId: number) => axios.delete(delPhotoFromProduct(photoId));

export function setMainPhoto(id: number) {
  return axios.post(setProductMainPhotoUrl(id));
}

export const getReviews = (productId: number, perPage: number, page: number) =>
  axios.get(getReviewsUrl(productId, perPage, page));

export const createReview = (productId: number, body: IReviewCreate) =>
  axios.post(createReviewUrl(productId), body);

export const delReview = (reviewId: number) => axios.delete(delReviewUrl(reviewId));

export const getMyFavorites = () => axios.get('/api/shop/favorites');

export const addMyFavorites = (product_id: number) =>
  axios.post('/api/shop/favorites', {}, { params: { product_id } });

export const deleteMyFavorites = (product_id: number) =>
  axios.delete('/api/shop/favorites', { params: { product_id } });

export const changeMyFavorites = (product_id: number, deleteFav: boolean) =>
  deleteFav ? deleteMyFavorites(product_id) : addMyFavorites(product_id);

export const getProductsForDays = ({
  page = 1,
  perPage = 20,
  forDays = 0,
}: {
  page: number;
  perPage: number;
  forDays: number;
}) =>
  axios.post(
    PRODUCTS_URL,
    {
      for_days: forDays,
    },
    {
      params: {
        page,
        per_page: perPage,
      },
    }
  );

export const getForDays = () => axios.get(FOR_DAYS_URL);
export const addForDays = (days: number) => axios.post(`${FOR_DAYS_URL}?days=${days}`);

export const editStock = (product_id: number, body: FormData) =>
  axios.post(`/api/stock_info/${product_id}`, body);
export const searchProducts = (text: string) =>
  axios.get('/api/shop/products/search', { params: { text } });
